<template>
    <div>
        <v-container>
            <v-row class="ma-0">
                <v-col cols="6" class=" text-right">
                <p class="headline">Laporan RUP dan Paket Kegiatan</p>
                </v-col>
                <v-cols cols="2">
                    <v-select
                        :items="itemsTahunAnggaran"
                        label="Tahun Anggaran"
                        v-model="tahunAnggaranSel"
                        single-line
                        dense
                        class="headline"
                        @change="tahunAnggaranSelChange"
                    ></v-select>
                </v-cols>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12">
                    <v-data-table
                        :headers="table.headers"
                        :items="table.items"
                        :items-per-page="5"
                        item-key="id"
                        class="elevation-1"
                    >
                        <template v-slot:item.id="{item}">
                            <v-btn color="success" x-small @click="detailPaket(item)">
                                Paket
                            </v-btn>
                        </template>
                        <template v-slot:item.divisi="{item}">
                            {{ getDivisi(item.divisi) }}
                        </template>
                        <template v-slot:item.pagu="{item}">
                            {{ getNumberSep(item.pagu) }}
                        </template>
                        <template v-slot:item.paguTerpakai="{item}">
                            {{ getNumberSep(item.paguTerpakai) }}
                        </template>
                        <template v-slot:item.sisaPagu="{item}">
                            {{ getNumberSep(item.sisaPagu) }}
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>
                                    <v-btn color="primary darken-1" @click="exportExcelRup()">Export Excel</v-btn>
                                </v-toolbar-title> 
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12">
                    <v-data-table
                        :headers="table3.headers"
                        :items="table3.items"
                        :items-per-page="5"
                        item-key="id"
                        class="elevation-1"
                    >
                        <template v-slot:item.namaDivisi="{item}">
                            {{ getDivisi(item.divisi) }}
                        </template>
                        <template v-slot:item.pagu="{item}">
                            {{ getNumberSep(item.pagu) }}
                        </template>
                        <template v-slot:item.paguTerpakai="{item}">
                            {{ getNumberSep(item.paguTerpakai) }}
                        </template>
                        <template v-slot:item.sisaPagu="{item}">
                            {{ getNumberSep(item.sisaPagu) }}
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>
                                    <v-btn color="secondary" @click="exportExcelRup2()">Export Excel</v-btn>
                                </v-toolbar-title> 
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        <!-- Dialog Program -->
        <v-dialog v-model="detail"  persistent max-width="1200px">
        <v-card>
            <v-card-title class="blue lighten-1 white--text">
            <span class="headline">Detail Paket</span>
            </v-card-title>
            <v-card-text>
                <v-row class="ma-0">
                    <v-col cols="12">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Nama Kegiatan</th>
                                        <th class="text-left">Nama Paket</th>
                                        <th class="text-right">Nilai Paket</th>
                                        <th class="text-right">Nilai Kontrak</th>
                                        <th class="text-right">Nilai Pagu</th>
                                        <th class="text-right">Pagu Terpakai</th>
                                        <th class="text-right">Sisa Pagu</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left">{{ table2.kegiatan.nama }}</td>
                                        <td class="text-left"></td>
                                        <td class="text-left"></td>
                                        <td class="text-left"></td>
                                        <td class="text-right">{{ getNumberSep(table2.kegiatan.pagu) }}</td>
                                        <td class="text-right">{{ getNumberSep(table2.kegiatan.paguTerpakai) }}</td>
                                        <td class="text-right">{{ getNumberSep(table2.kegiatan.sisaPagu) }}</td>

                                    </tr>
                                    <tr
                                    v-for="item2 in table2.items"
                                    :key="item2.id"
                                    >
                                        <td></td>
                                        <td>{{ item2.nama }}</td>
                                        <td class="text-right">{{ getNumberSep(item2.totalPagu) }}</td>
                                        <td class="text-right">{{ getNumberSep(item2.nilaiKontrak) }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="text-center"><b>Total</b></td>
                                        <td class="text-right"><b>{{ getNumberSep(table2.totalPaguTerpakai) }}</b></td>
                                        <td class="text-right"><b>{{ getNumberSep(table2.totalNilaiKontrak) }}</b></td>
                                        <td class="text-right"><b>{{ getNumberSep(table2.kegiatan.pagu) }}</b></td>
                                        <td class="text-right"><b>{{ getNumberSep(table2.kegiatan.paguTerpakai) }}</b></td>
                                        <td class="text-right"><b>{{ getNumberSep(table2.kegiatan.sisaPagu) }}</b></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn dark color="orange darken-1" @click="close">Tutup</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>
const axios = require("axios").default;
const apiUrl = process.env.VUE_APP_ROOT_API;
import { getValueItem } from "./../../lib/viewLib";
import { tahunAnggaran } from './../../lib/viewLib'

export default{
    data() {
        return {
            itemsTahunAnggaran: tahunAnggaran,
            tahunAnggaranSel: new Date().getFullYear(),
            objItemsDivisi: [],
            detail: false,
            table: {
                headers: [
                    { text: 'Paket', value: 'id' },
                    { text: 'Kode RUP', align: 'start', sortable: false, value: 'kodeRup'},
                    { text: 'Nama Kegiatan', value: 'nama'},
                    { text: 'Divisi', value: 'divisi'},
                    { text: 'Jumlah Pagu(Rp.)', value: 'pagu', align: 'end'},
                    { text: 'Pagu Terpakai', value: 'paguTerpakai', align: 'end'},
                    { text: 'Sisa Pagu', value: 'sisaPagu', align: 'end'},
                ],
                items: [] 
            },
            table2: {
                kegiatan: [],
                items: [],
                totalPaguTerpakai: 0,
                totalNilaiKontrak: 0
            },
            table3: {
                headers: [
                    { text: 'Kode Divisi', align: 'start', sortable: false, value: 'divisi'},
                    { text: 'Nama Divisi', value: 'namaDivisi'},
                    { text: 'Pagu', value: 'pagu', align: 'end'},
                    { text: 'Terpakai', value: 'paguTerpakai', align: 'end'},
                    { text: 'Sisa Pagu', value: 'sisaPagu', align: 'end'},
                ],
                items: [] 
            },
            
        }
    },
    created() {
        this.getDataDivisi();
        this.getData();
        this.getDataSummaryDivisi();
    },
    methods: {
        getDivisi(divisi) { 
            console.log('divisi', divisi)
            return getValueItem(this.objItemsDivisi, divisi)
        },
        getDataDivisi() {
            axios.get(`${apiUrl}/monitor2/masterdivisi`)
            .then((response) => {
                let dataDivisi = response.data.data;
                this.objItemsDivisi = new Array;

                dataDivisi.forEach(el => {
                    this.objItemsDivisi.push({
                        text: el.nama,
                        value: el.kode,
                        parent: el.parent,
                        nick: el.nick
                    })
                })
            })
            .catch((error) => {
                console.error(error);
            });
        },
        getData() {
            axios.get(`${apiUrl}/laporan/laporan-rup-dan-paket-kegiatan/${this.tahunAnggaranSel}`)
            .then((response) => {
                this.table.items = response.data.data;
            })
            .catch((error) => {
                console.error(error);
            });
        },
        getDataSummaryDivisi() {
            axios.get(`${apiUrl}/laporan/laporan-rup-summary-divisi/${this.tahunAnggaranSel}`)
            .then((response) => {
                this.table3.items = response.data.data;

            })
            .catch((error) => {
                console.error(error);
            });
        },
        tahunAnggaranSelChange() {
            this.getData();
            this.getDataSummaryDivisi();
        },
        getNumberSep: function(data) {
            return parseInt(data, 10).toLocaleString('de-DE')
        },
        detailPaket(item) {
            let paket = item.paket;
            this.detail = true;
            this.table2.items = paket;
            this.table2.kegiatan = item;
            let totalTerpakai = 0;
            let totalNilaiKontrak = 0;
            paket.forEach(element => {
                totalTerpakai += element.totalPagu;
                totalNilaiKontrak += element.nilaiKontrak;
            });
            this.table2.totalPaguTerpakai = totalTerpakai;
            this.table2.totalNilaiKontrak = totalNilaiKontrak;
        },
        close() {
            this.detail = false;

        },
        exportExcelRup() {
            axios.get(`${apiUrl}/laporan/xls/laporan-rup/${this.tahunAnggaranSel}`)
            .then((response) => {
                if(response.status === 200) {
                    this.getLinkDownload(response.data.file);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        exportExcelRup2() {
            axios.get(`${apiUrl}/laporan/xls/laporan-rup2/${this.tahunAnggaranSel}`)
            .then((response) => {
                if(response.status === 200) {
                    this.getLinkDownload(response.data.file);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        getLinkDownload: function(dok) {
            axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = dok
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },
    }
}
</script>

<style scoped>
    .container{
        max-width: 100vw;
        padding:0px;
    }

</style>